/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prop_LabelsInputs */

const en_prop_labels = /** @type {(inputs: Prop_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labels`)
};

const de_prop_labels = /** @type {(inputs: Prop_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labels`)
};

/**
* | output |
* | --- |
* | "Labels" |
*
* @param {Prop_LabelsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const prop_labels = /** @type {((inputs?: Prop_LabelsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prop_LabelsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_prop_labels(inputs)
	return en_prop_labels(inputs)
});